import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Grid,
  TextField,
  CircularProgress,
} from "@mui/material";
import "../../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../../Components/Common/Dialog/DialogComponents";
import { connect } from "react-redux";
import * as yup from "yup";
import { useFormik } from "formik";
import { useXssGuard } from "Hooks/useXssGuard";
import { makeStyles } from "@mui/styles";
import { START_DRUG_NAME_UPDATE } from "../../../Actions/CollectionAction";
import DrugAutoComplete from "../../../Components/Patients/DrugAutoComplete";
const useStyle = makeStyles((theme) => ({
  rsDrugName: {
    "&>div": {
      height: "110px !important",
      "&>textarea": {
        height: "92px !important",
      },
    },
  },
  rsDailogActions:{
    padding:"15px !important"
  }
}));

const EditDrugDialog = (props) => {
  const {
    open,
    setOpen,
    editData,
    setEditData,
    updateDrugNameAction,
    collectAndRemoveData,
    collectAndUncollectedViewRxDetails,
    collectionViewRxAction,
    medications,
    editDrugOpen,
    setEditDrugOpen,
    setSubscritionDialog,
    loginUserDetail,
  } = props;
  const formState = {
    drug_name: "",
    quantity: "",
  };
  const formStateDrug = {
    id: "",
    meditation_id: "",
    name: "",
    quantity: "",
  };
  const [isOpenDate, setIsOpenDate] = React.useState(false);
  const [drug, setDrug] = React.useState(formState);
  const [drugName, setDrugName] = React.useState({});
  const [drugModi, setDrugModi] = React.useState(formStateDrug);
  const [quntity, setQuntity] = React.useState(formState);
  const classes = useStyle();
  let today = new Date();
  let yestarday = new Date(new Date(today).setDate(today.getDate() - 1));
  //   /** Validation schema */
  const DateSchema = yup.object().shape({
    // drug: yup.string().required("The drug name is required."),
    // quantity: yup.string().required("The quantity field is required."),
  });

  //   /** Handle Update Date Function */
  const handleUpdateDrug = (formValues) => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    const payload = {
      drug_name: drugModi?.name,
      quantity: quntity,
    };
    let payLoad = {
      type: "un_collected",
    };
    if (
      quntity === "" &&
      (drugModi?.name === "" || drugModi?.name === undefined)
    ) {
      setErrors({
        drug_name: "Please enter drug name",
        // quantity: "Please enter quantity",
      });
    } else {
      // if (quntity === "") {
      //   // setErrors({
      //   //   quantity: "Please enter quantity",
      //   // });
      // } else
      if (quntity <= 0 && quntity !== "") {
        setErrors({
          quantity: "Please enter number greater then 0",
        });
        if (drugModi?.name === "" || drugModi?.name === undefined) {
          setErrors({
            drug_name: "Please enter drug name",
            quantity: "Please enter number greater then 0",
          });
        }
      } else if (drugModi?.name === "" || drugModi?.name === undefined) {
        setErrors({
          drug_name: "Please enter drug name",
          // quantity: "Please enter quantity",
        });
      } else {
        updateDrugNameAction(
          editData?.medication_id,
          payload,
          collectAndUncollectedViewRxDetails,
          payLoad
        );
      }
    }
    // if (quntity <= 0) {
    //   setErrors({
    //     quantity: "Please enter number greater then 0",
    //   });
    // } else {
    //   updateDrugNameAction(
    //     editData?.medication_id,
    //     payload,
    //     collectAndUncollectedViewRxDetails,
    //     payLoad
    //   );
    // } }
    // }

  };
  const { guardedSubmit: xssGuardedEditDrug } = useXssGuard(handleUpdateDrug);

  //   /** UseFormik */
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
    setErrors,
    setFieldValue,
    handleBlur,

} = useFormik({
    initialValues: { drug },
    validationSchema: DateSchema,
    enableReinitialize: true,
    onSubmit: xssGuardedEditDrug,
  });

  //   /** Handle Close Funcation */
  const handleClose = () => {
    setOpen(false);
    setEditData({});
    resetForm();
    setDrug({});
    // setEditDrugOpen(false);
  };

  /** User popup popup then show selected date useEffect */
  useEffect(() => {
    if (Object.keys(editData)?.length) {
      setDrug({
        drug_name: editData || {},
        quantity: editData?.quantity || "",
      });
      setDrugName(editData ? editData || {} : {});
      setQuntity(editData?.quantity ? editData?.quantity || "" : "");
    }
    // setEditDrugOpen(true);
  }, [open]);

  useEffect(() => {
    setDrugModi({
      id: editData?.id,
      meditation_id: editData?.medication_id,
      name: editData?.drug_name,
      quantity: editData?.quantity,
    });
  }, [editData]);

  /** Server Side validation UseEffect */
  useEffect(() => {
    const errors = collectAndRemoveData?.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};

      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        return item;
      });
      setErrors(obj);
    }
  }, [collectAndRemoveData?.error]);

  //   /** Date Update useEffect */
  useEffect(() => {
    if (
      !collectAndRemoveData?.loading &&
      Object.keys(collectAndRemoveData?.data || {})?.length > 0
    ) {
      handleClose();
      let payload = {
        type: "un_collected",
      };
      // setEditDrugOpen(false);
      // collectionViewRxAction(collectAndUncollectedViewRxDetails, payload);
    }
  }, [collectAndRemoveData]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"xs"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle
          title={"Edit Medication"}
          handleClose={handleClose}
        />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <DialogContent>
            <Grid container columnSpacing={2.5} rowSpacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <DrugAutoComplete
                  type="collect"
                  // listOpen={true}
                  fullWidth
                  filterMedication={medications}
                  className={classes.rsDrugAutoCompleteBox}
                  value={drugModi}
                  onChange={(e, value) => {
                    value = value
                      ? {
                          ...value,
                          name: value?.label,
                        }
                      : value;
                    delete value?.label;

                    handleChange("drug_name", value);
                    if (quntity <= 0) {
                      setErrors({
                        drug_name: "",
                        quantity: "Please enter number greater then 0",
                      });
                    } else {
                      setErrors({});
                    }
                    setDrugModi({
                      id: value?.id,
                      meditation_id: "",
                      name: value?.name,
                      quantity: editData?.quantity,
                    });
                  }}
                  excludeDrugs={medications}
                  renderInput={(params) => (
                    <>
                      <TextField
                        {...params}
                        label="Drug Name *"
                        placeholder="Choose Drug"
                        error={touched?.drug?.drug_name && errors?.drug_name}
                        helperText={
                          touched?.drug?.drug_name && errors?.drug_name
                        }
                        onBlur={handleBlur}
                      />
                    </>
                  )}
                />
                {/* <TextField
                  className={classes.rsDrugName}
                  multiline
                  rows={3}
                  maxRows={5}
                  variant="outlined"
                  fullWidth
                  placeholder=" Drug Name *"
                  label=" Drug Name *"
                  size="small"
                  id="drug_name"
                  name="drug_name"
                  value={drugName}
                  onChange={(e, value) => {
                    handleChange("drug_name", e.target.value);
                    setDrugName(e.target.value);
                  }}
                  error={touched?.drug?.drug_name && errors?.drug_name}
                  helperText={touched?.drug?.drug_name && errors?.drug_name}
                  onBlur={handleBlur}
                /> */}
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder=" Quantity "
                  inputProps={{ maxLength: 10 }}
                  label="Quantity "
                  size="small"
                  id="quantity"
                  name="quantity"
                  value={quntity}
                  onChange={(e, value) => {
                    setQuntity(e.target.value);
                    handleChange("quantity", e.target.value);
                    setErrors({});
                  }}
                  onBlur={handleBlur}
                  error={touched?.drug?.quantity && errors?.quantity}
                  helperText={touched?.drug?.quantity && errors?.quantity}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className={classes.rsDailogActions}>
            <Button
              variant="contained"
              type="submit"
              disabled={collectAndRemoveData?.loading}
              startIcon={
                collectAndRemoveData?.loading && (
                  <CircularProgress color="white" size="20px" />
                )
              }
            >
              Submit
            </Button>
            <Button variant="outlined" onClick={() => handleClose()}>
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  updateRepeatOrderDates: state.order.updateRepeatOrderDates,
  collectAndRemoveData: state.collection.collectAndRemoveData,
});
const mapDispatchToProps = (dispatch) => ({
  updateDrugNameAction: (id, payload, collectionId, collectionPayload) =>
    dispatch({
      type: START_DRUG_NAME_UPDATE,
      id,
      payload,
      collectionId,
      collectionPayload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDrugDialog);
